<template>
    <b-list-group flush v-if="!isDataLoading">
        <slot v-if="dataCount > 0"></slot>
        <app-no-data-image v-else width="100%" imgSrc="no-inbox.png" imageClass="w-sm-75 w-50" />
    </b-list-group>
    <b-list-group flush v-else>
        <b-list-group-item>
            <b-skeleton width="85%" class="mb-1"></b-skeleton>
        </b-list-group-item>
        <b-list-group-item>
            <b-skeleton width="85%" class="mb-1"></b-skeleton>
        </b-list-group-item>
        <b-list-group-item>
            <b-skeleton width="85%" class="mb-1"></b-skeleton>
        </b-list-group-item>
    </b-list-group>
</template>
<script>
    export default {
        props: {
            isDataLoading : {
                type: Boolean,
                default: false,
            },
            dataCount: {
                type: Number,
                default: 0
            }
        }
    }
</script>